var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoftFx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.185 16.088v9.77c0 .683-.554 1.236-1.238 1.236H11.85a.124.124 0 01-.123-.123V17.2c0-.683.553-1.236 1.237-1.236h2.097c.069 0 .124.056.124.123z",
    fill: "url(#soft-fx_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.355 1.305V12.74a.124.124 0 01-.123.124h-2.11a1.237 1.237 0 01-1.238-1.236V.193c0-.068.055-.123.124-.123h2.11c.683 0 1.237.552 1.237 1.235z",
    fill: "url(#soft-fx_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.355 21.83v8.79c0 .682-.554 1.235-1.238 1.235h-2.11a.123.123 0 01-.123-.124v-8.789c0-.682.554-1.236 1.238-1.236h2.11c.068 0 .123.056.123.124z",
    fill: "url(#soft-fx_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.461 24.853v5.767c0 .682-.553 1.235-1.237 1.235h-2.1A.123.123 0 010 31.73v-5.766c0-.683.554-1.236 1.238-1.236h2.1c.068 0 .123.056.123.124z",
    fill: "url(#soft-fx_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.185 6.07v5.009a.124.124 0 01-.124.124h-2.097a1.236 1.236 0 01-1.237-1.236V4.958c0-.068.055-.124.123-.124h2.097c.684 0 1.238.554 1.238 1.236z",
    fill: "url(#soft-fx_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.461 1.306v5.767a.123.123 0 01-.123.123h-2.1A1.237 1.237 0 010 5.962V.194C0 .125.055.07.124.07h2.1c.684 0 1.237.553 1.237 1.236z",
    fill: "url(#soft-fx_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.85 31.736v-8.212c0-.786-.314-1.54-.87-2.096l-3.036-3.029a2.974 2.974 0 00-2.1-.868h-8.227a.124.124 0 00-.124.124v8.211c0 .787.313 1.541.87 2.097l3.035 3.028a2.973 2.973 0 002.1.869h8.227a.124.124 0 00.124-.124z",
    fill: "url(#soft-fx_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.85.132v8.212c0 .786-.314 1.54-.87 2.096l-3.036 3.029a2.974 2.974 0 01-2.1.868h-8.227a.124.124 0 01-.124-.124V6.002c0-.787.313-1.541.87-2.097L21.398.877a2.972 2.972 0 012.1-.869h8.227c.069 0 .124.056.124.124z",
    fill: "url(#soft-fx_svg__paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.225 19.433h-10.042v3.938h10.042v-3.938z",
    fill: "url(#soft-fx_svg__paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.761.766v3.937h-8.394c-.546 0-1.092.023-1.633.111-1.542.34-2.654 1.834-2.771 3.386-.045.815-.038 1.631-.034 2.444h-.006v1.92h10.628V16.5h-10.622c.007 5.017.002 10.03.002 15.045h-4.036c.006-4.897 0-9.794.006-14.694v-4.916c.053-1.775-.153-3.579.161-5.337.448-2.37 2.164-4.447 4.408-5.291 1.042-.428 2.139-.53 3.248-.54.09-.002.177-.002.268-.002h8.775z",
    fill: "url(#soft-fx_svg__paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.145 1.135c-.006 1.188-.006 2.378.002 3.568h-2.185c-.55 0-1.098.023-1.64.11-1.543.34-2.655 1.835-2.772 3.387-.043.814-.036 1.631-.032 2.443h-.006v1.92h6.633v3.938h-6.627c.007 5.017.002 10.03.002 15.044h-4.036c.005-4.896 0-9.793.005-14.693v-4.916c.054-1.775-.154-3.58.16-5.337.448-2.37 2.165-4.447 4.408-5.291 1.127-.462 2.32-.542 3.52-.542h2.569V.78h.001l-.002.354z",
    fill: "url(#soft-fx_svg__paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.488 31.174v.37h-2.569c-1.199 0-2.391-.08-3.519-.542-2.243-.845-3.96-2.92-4.408-5.29-.314-1.759-.106-3.563-.159-5.338v-4.916c-.007-4.9 0-9.797-.007-14.694h4.037l.001 10.692v1.108h6.624V16.5h-6.624v3.245h-.009v1.92h.006c-.004.813-.011 1.63.032 2.444.117 1.552 1.229 3.046 2.771 3.386.543.088 1.092.11 1.64.11h2.186c-.007 1.19-.007 2.38-.002 3.568z",
    fill: "url(#soft-fx_svg__paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181 31.547h-5.275l-.309-.585-1.149-2.193c-.4-.78-.813-1.558-1.226-2.333-1.158-2.164-2.33-4.315-3.216-6.582a25.967 25.967 0 01-.569-1.604l-.194-.62-.193.62a26.816 26.816 0 01-.569 1.604c-.885 2.267-2.058 4.418-3.216 6.582-.413.775-.826 1.554-1.226 2.333l-1.15 2.194-.308.584h-5.275l4.986-8.741 1.32-2.303V20.5c.126-.223.254-.449.381-.678l.059-.104 1.038-1.815.153-.269a3.77 3.77 0 00.418-1.734c0-.65-.163-1.261-.45-1.796l-1.419-2.496-3.07-5.398-1.085-1.901-1.688-2.964-.332-.581h5.204l.316.581 1.659 3.026.592 1.075c.781 1.451 1.549 2.919 2.358 4.37.33.6.627 1.218.904 1.844.14.31.272.624.402.939l.191.47.192-.47c.13-.315.262-.629.402-.939.277-.626.574-1.244.904-1.845.809-1.45 1.577-2.918 2.358-4.369l.592-1.075 1.659-3.026.316-.581h5.205l-.333.581-1.687 2.964-1.087 1.9-3.069 5.399-1.419 2.496a3.789 3.789 0 00-.45 1.796c0 .625.15 1.215.418 1.734l.153.269 1.037 1.815.06.104c.127.23.255.455.381.678v.002l1.319 2.303 4.987 8.74z",
    fill: "url(#soft-fx_svg__paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.43 5.55c3.052-.523 6.377-.35 9.133 1.193 2.207 1.227 3.668 3.51 4.291 5.932.646 2.372.6 4.85.56 7.286-.086 2.975-.813 6.117-2.856 8.366-2.035 2.25-5.13 3.232-8.088 3.213-2.946.08-6.13-.614-8.27-2.792-2.12-2.113-2.903-5.195-3.066-8.115-.113-3.48-.178-7.187 1.54-10.332 1.334-2.565 3.958-4.268 6.755-4.75zm1.145 3.192c-1.477.252-2.871 1.063-3.713 2.333-1.231 1.866-1.507 4.18-1.528 6.372-.013 2.139-.06 4.335.626 6.392.475 1.515 1.443 2.943 2.894 3.648 1.803.853 3.923.92 5.825.382 1.6-.455 2.908-1.697 3.555-3.23 1.065-2.472.918-5.235.893-7.871-.087-2.306-.491-4.846-2.206-6.526-1.654-1.63-4.17-1.858-6.346-1.5z",
    fill: "url(#soft-fx_svg__paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.587 26.567c-.615 1.818-2.113 3.216-3.832 3.966-2.31 1.037-4.925 1.189-7.408.852-2.23-.323-4.485-1.28-5.928-3.092-.683-.838-1.118-1.842-1.388-2.887l-.107-.447-.161-.681h3.952c.475 1.897 2.241 3.15 4.078 3.492 2.012.374 4.286.25 6.005-.985 1.036-.717 1.624-2.104 1.195-3.331-.432-1.26-1.662-1.984-2.829-2.433-2.348-.883-4.75-1.621-7.09-2.529-1.826-.736-3.583-2.066-4.168-4.043C40.28 12.267 40.662 9.713 42.2 8c1.41-1.583 3.507-2.345 5.554-2.611 2.679-.298 5.579-.037 7.872 1.51 1.37.91 2.345 2.34 2.782 3.925l.11.447.173.695h-3.958C54.274 10.53 53 9.526 51.582 9.16c-1.897-.5-4.08-.455-5.767.651-1.014.654-1.577 1.98-1.181 3.155.33 1.048 1.328 1.671 2.288 2.055 2.085.772 4.186 1.492 6.275 2.259 1.697.626 3.378 1.522 4.513 2.981 1.375 1.754 1.573 4.233.877 6.307z",
    fill: "url(#soft-fx_svg__paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint0_linear",
    x1: 11.379,
    y1: 16.001,
    x2: 16.715,
    y2: 26.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint1_linear",
    x1: 5.535,
    y1: 0.111,
    x2: 12.142,
    y2: 11.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint2_linear",
    x1: 5.535,
    y1: 21.739,
    x2: 10.118,
    y2: 31.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint3_linear",
    x1: -0.347,
    y1: 24.752,
    x2: 2.136,
    y2: 32.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint4_linear",
    x1: 11.379,
    y1: 4.855,
    x2: 13.403,
    y2: 11.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint5_linear",
    x1: -0.347,
    y1: 0.094,
    x2: 2.136,
    y2: 7.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint6_linear",
    x1: 16.052,
    y1: 17.578,
    x2: 18.662,
    y2: 34.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint7_linear",
    x1: 31.849,
    y1: 0.008,
    x2: 17.521,
    y2: 14.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint8_linear",
    x1: 120.175,
    y1: 19.446,
    x2: 120.462,
    y2: 24.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint9_linear",
    x1: 134.189,
    y1: 0.866,
    x2: 143.888,
    y2: 34.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint10_linear",
    x1: 89.399,
    y1: 0.866,
    x2: 103.171,
    y2: 31.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint11_linear",
    x1: 104.742,
    y1: 0.864,
    x2: 118.514,
    y2: 31.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint12_linear",
    x1: 154.728,
    y1: 0.865,
    x2: 161.856,
    y2: 36.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint13_linear",
    x1: 60.842,
    y1: 5.369,
    x2: 66.422,
    y2: 35.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soft-fx_svg__paint14_linear",
    x1: 37.834,
    y1: 5.367,
    x2: 44.25,
    y2: 35.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}

export default SvgSoftFx;